'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Promotionsprogrammtyp = require('../entity').Promotionsprogrammtyp;

module.exports = function (connection) {
  return {
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(Promotionsprogrammtyp, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(Promotionsprogrammtyp, 'byNameLike', 'name')(name, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Promotionsprogrammtyp, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byTypIdEquals: function byTypIdEquals(typid, additionalParams) {
      return templates.searchTemplate(connection)(Promotionsprogrammtyp, 'byTypIdEquals', 'typid')(typid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Promotionsprogrammtyp, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('promotionsprogrammtyp')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/promotionsprogrammtyp.js
// module id = 4o/2
// module chunks = 0